<template>
  <div>
    <div class="mb-2">
      <TableImportErrorGlobal :columns="columns" v-if="hasErrors" :response-error="listErrors"/>
      <div v-else>
        <div>
          <p>Bước 1: Tải file mẫu</p>
          <div>
            <el-button :loading="download_default" class="btn btn-primary " size="small" @click="exportFileMau">
              <i class="el-icon-download text--white"></i>
              <span class="text--white">Tải xuống</span>
            </el-button>
          </div>
        </div>
        <div class="mt-6">
          <p>Bước 2: Tải file excel lên hệ thống</p>
          <div class="mb-2">
            <el-upload
                ref="upload"
                accept=".xlsx"
                :limit="1"
                list-type="text"
                action=""
                :file-list="fileList"
                :on-change="handleChange"
                :on-remove="handleRemove"
                :auto-upload="false"
                :multiple="false"
            >
              <el-button class="btn btn-warning " size="small">
                <i class="el-icon-upload2 text--white"></i>
                <span class="text--white">Tải lên</span>
              </el-button>
            </el-upload>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <el-button @click="handleCancel">Hủy</el-button>
      <el-button :disabled="disableImport || disabledSubmit()" :loading="loading" type="success" class="btn btn-success"
                 @click="checkImport ? handleImportFileExcel() : handlePreviewImportFileExcel()">
        {{ checkImport ? 'Import ' : 'Kiểm tra data' }}
      </el-button>
    </div>
  </div>
</template>

<script>
import TableImportErrorGlobal from "@/view/pages/classes/TableImportErrorGlobal.vue";
import {
  EXPORT_FILE_DEFAULT_CLASS_TIMESHEETS,
  IMPORT_CLASS_TIMESHEETS,
  PREVIEW_IMPORT_CLASS_TIMESHEETS
} from "@/core/services/store/course/classes.module";
import * as XLSX from "xlsx";

export default {
  name: 'ImportClassTimeSheet',
  components: { TableImportErrorGlobal },
  data() {
    return {
      download_default: false,
      loading: false,
      fileList: [],
      fileImport: null,
      disableImport: true,
      listErrors: [],
      checkImport: false,
      columns: {
        'date': 'Ngày',
        'ma_giao_vien': 'Mã GV',
        'thoi_gian_bat_dau': 'Thời gian bắt đầu',
        'thoi_gian_ket_thuc': 'Thời gian kết thúc',
        'don_gia': 'Đơn giá',
        'note': 'Note',
        'ten_co_so_day': 'Cơ sở',
        'errors': 'Trạng thái'
      },
    }
  },
  computed: {
    hasErrors() {
      return this.listErrors && this.listErrors.length > 0;
    },
  },
  methods: {
    exportFileMau() {
      this.download_default = true
      this.$store.dispatch(EXPORT_FILE_DEFAULT_CLASS_TIMESHEETS).then((res) => {
        this.download_default = false
        this.$notify({
          title: 'Thành công',
          message: res.message,
          type: 'success'
        })
      }).catch((error) => {
        this.download_default = false
        this.$notify({
          title: 'Thất bại',
          message: error.data.message,
          type: 'error'
        })
      })
    },
    handleCancel() {
      if (this.hasErrors) {
        this.cancelImport();
      } else {
        this.closeDialog()
      }
    },
    closeDialog() {
      this.$emit('closeDialog')
    },
    cancelImport() {
      this.fileList = []
      this.fileImport = null;
      this.listErrors = [];
      this.startImport = true;
      this.checkImport = false;
      this.disableImport = true;
    },
    handleRemove() {
      this.fileList = []
      this.listErrors = [];
      this.checkImport = false;
      this.disableImport = true;
      this.startImport = true;
    },
    async handlePreviewImportFileExcel() {
      this.disableImport = true;
      this.loading = true;
      if (!this.fileImport) {
        this.$notify({title: "Thất bại", message: "Chưa có file nào được chọn", type: "error"});
        this.disableImport = false;
        this.loading = false;
        return;
      }
      if (this.dataImport.length === 0) {
        this.$message.warning("Bạn không thể import khi file excel không có bản ghi nào");
        this.disableImport = false;
        this.loading = false;
        return;
      }
      try {
        const res = await this.$store.dispatch(PREVIEW_IMPORT_CLASS_TIMESHEETS, this.dataImport);
        const rawErrors = res?.data?.dataImport || [];
        this.checkImport = res.data?.checkImport;
        this.dataImport = rawErrors;
        this.isBack = true;
        this.loading = false;
        this.listErrors = rawErrors.map(item => ({
          date: item.date,
          ma_giao_vien: item.ma_giao_vien,
          ten_giao_vien: item.ten_giao_vien,
          thoi_gian_bat_dau: item.thoi_gian_bat_dau,
          thoi_gian_ket_thuc: item.thoi_gian_ket_thuc,
          don_gia: item.don_gia,
          ma_co_so_day: item.ma_co_so_day,
          ten_co_so_day: item.ten_co_so_day,
          errors: item.error || []
        }));
        if (this.listErrors?.length > 0) {
          this.$emit('errors', this.hasErrors)
        }
      } catch (error) {
        this.$message.error("Import thất bại");
      } finally {
        this.disabledSubmit()
        this.disableImport = false;
        this.loading = false;
      }
    },
    disabledSubmit() {
      return this.listErrors.filter(item => item.errors.length > 0).length > 0
    },
    async handleImportFileExcel() {
      this.loading = true;
      try {
        const res = await this.$store.dispatch(IMPORT_CLASS_TIMESHEETS, this.dataImport);
        if (!res.error) {
          this.$message.success("Import thành công");
        }
      } catch (e) {
        this.$message.error("Import thất bại");
      } finally {
        this.loading = false;
        this.$emit('closeDialog');
      }
    },
    handleChange(file, fileList) {
      this.fileList = fileList
      this.fileImport = file.raw;
      this.disableImport = false;
      this.parseExcel(this.fileImport);
    },
    parseExcel(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const workbook = XLSX.read(new Uint8Array(e.target.result), {type: "array"});
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const rawData = XLSX.utils.sheet_to_json(sheet, {header: 1, cellDates: true, raw: false});
        const formattedData = rawData.map(row =>
            row.map(cell => cell instanceof Date
                ? cell.toISOString().split('T')[0]  // yyyy-mm-dd
                : cell
            )
        );
        const [headers, ...rows] = formattedData;
        const columnMap = {
          "Ngày": "ngay",
          "ID Lớp": "ma_lop",
          "Lớp": "ten_lop",
          "Lý do": "ly_do",
          "Mã giáo viên": "ma_giao_vien",
          "Số công trừ": "so_cong_tru",
          "Lịch học": "schedule_id",
        };
        const mappedHeaders = headers.map(h => columnMap[h] || h);
        this.dataImport = rows
            .filter(row => row.length > 0)
            .map(row => {
              const item = {};
              mappedHeaders.forEach((key, i) => item[key] = row[i]);
              return {...item, error: []};
            });
      };
      reader.readAsArrayBuffer(file);
    },
  }
}
</script>

<style scoped>

</style>